// extracted by mini-css-extract-plugin
export var ballImg = "timer-module--ballImg--SHgFj";
export var cardImg = "timer-module--cardImg--I3qkw";
export var clockImg = "timer-module--clockImg--HRaSY";
export var clockImgStickerMode = "timer-module--clockImgStickerMode--GLcC4";
export var closeBtn = "timer-module--closeBtn--dSbM-";
export var clsBtn = "timer-module--clsBtn--IErfP";
export var descr = "timer-module--descr---xSRc";
export var giftBlueImg = "timer-module--giftBlueImg--7fB7S";
export var giftImg = "timer-module--giftImg--mEbPJ";
export var giftNYImg = "timer-module--giftNYImg--3VioI";
export var pawImg = "timer-module--pawImg--wsUfw";
export var root = "timer-module--root--BZ4oj";
export var rootNY = "timer-module--rootNY--awHQc";
export var squirrelImg = "timer-module--squirrelImg--BHVU0";
export var stickerImg = "timer-module--stickerImg--GZxQS";
export var timer = "timer-module--timer--Qg7fR";
export var timerNY = "timer-module--timerNY--D4A+O";
export var treeImg = "timer-module--treeImg--SvwmK";
export var wrapper = "timer-module--wrapper--FO6b6";
export var wrapperNY = "timer-module--wrapperNY--n+RUk";
export var wrapperStickerMode = "timer-module--wrapperStickerMode--c9-8n";